module.exports = __webpack_public_path__ + "static/media/money-cake.eb5efd8c.svg";